import { EntityRepository, Repository } from "typeorm";
import { EmployeeLeaves } from "./employee-leaves.entity";

@EntityRepository(EmployeeLeaves)
export class EmployeeLeavesRepository extends Repository<EmployeeLeaves> {


}